"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactTableStyle = void 0;
const react_1 = require("@emotion/react");
const ReactTableStyle = (0, react_1.css) `
  border-spacing: 0;
  border: 1px solid #dedede;
  width: 100%;
  max-height: 100%;
  font-size: 12px;

  .react-contextmenu-wrapper {
    display: contents;
  }

  tr {
    :last-child {
      td {
        border-bottom: 0;
      }
    }
  }

  th {
    position: sticky;
    background-color: white;
    z-index: 0;
    top: 0;
  }
  th,
  td {
    margin: 0;
    padding: 0.15rem 0.4rem;
    border-bottom: 1px solid #dedede;
    border-right: 1px solid #dedede;
  }
`;
exports.ReactTableStyle = ReactTableStyle;
